/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SettingManagementEditSettingRequest = {
    id: number;
    category?: SettingManagementEditSettingRequest.category;
    addr?: string;
    context?: string;
    contextEn?: string;
    contextCn?: string;
};

export namespace SettingManagementEditSettingRequest {

    export enum category {
        BREEDER = 'breeder',
        VARIETY = 'variety',
        PARENT_CARP = 'parent_carp',
        NOTE = 'note',
        AWARD_TITLE = 'award_title',
        AWARD_GROUP = 'award_group',
        OWNER = 'owner',
    }


}

